import type { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { useDebounce } from 'uikit';
import { extractValuesByKeys } from 'utils';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useIsUniqueGroupsActsName = (
    query: string | TypedDocumentNode<any, any>,
    groupName: string | undefined,
    workOrderId: number | undefined,
    actKC2GroupId: number | null,
): {
    isNotUniqueActKC2GroupName: boolean;
    currentStatusUniqueName: RequestStatus;
    makeResetIsUniqueActKC2GroupName: (value: unknown) => void;
} => {
    const dispatch = useDispatch();

    const [dataIsUniqueActKC2GroupName, currentStatusUniqueName, , requestIsUniqueActKC2GroupName] = useRequest({
        requestId: 'isUniqueActKC2GroupName',
        query,
        withEffect: false,
    });

    const debounceRequest = useDebounce(() => {
        if (groupName) {
            dispatch(
                requestIsUniqueActKC2GroupName({
                    groupName: groupName.trim(),
                    workOrderId,
                    actKC2GroupId,
                }),
            );
        }
    }, 300);

    const [makeResetIsUniqueActKC2GroupName] = useResetStoreData({
        requestId: 'isUniqueActKC2GroupName',
    });

    useEffect(() => {
        if (groupName?.length) {
            debounceRequest();
        }
    }, [debounceRequest, groupName]);

    const isUniqueActKC2GroupNameResult = extractValuesByKeys(['result'], dataIsUniqueActKC2GroupName ?? {});

    return {
        isNotUniqueActKC2GroupName: !isUniqueActKC2GroupNameResult?.result,
        currentStatusUniqueName,
        makeResetIsUniqueActKC2GroupName,
    };
};
